import Dialog from '@mui/material/Dialog'
import { DialogTitle } from '../../../../components/Dashboard/dashboard-style'
import Typography from '@mui/material/Typography'
import LoadingButton from '@mui/lab/LoadingButton'
import React, { useState } from 'react'
import { useCreateSnapshotMutation } from '../../../queries/useCreateSnapshotMutation'
import { useStrategy } from '../../../hooks/useStrategy'
import TextField from '@mui/material/TextField'
import { Stack, IconButton, Alert } from '@mui/material'
import Divider from '@mui/material/Divider'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import { SnackbarAlert } from '../../Alert/SnackbarAlert'

type Props = {
    toggleOpen: () => void
    toggle: boolean
}

const SnapshotModal = ({ toggleOpen, toggle }: Props) => {
    const [note, setNote] = useState('')
    const strategyId = useStrategy()._id
    const { isLoading, isError, isSuccess, mutate } = useCreateSnapshotMutation()
    const handleSnapshotCreate = () => {
        const snapshotBody = { snapshotSourceId: strategyId, snapshotNote: note }
        mutate(snapshotBody)
    }
    return (
        <>
            {isSuccess ? (
                <SnackbarAlert
                    message={'Snapshot in progress! Check the Snapshots view for status.'}
                    severity="success"
                    sx={{
                        '&.MuiSnackbar-root': {
                            position: 'absolute',
                            zIndex: 1000,
                            top: '55px',
                            right: '260px',
                            bottom: 'inherit',
                            left: 'inherit',
                        },
                    }}
                    open={isSuccess}
                    onClose={toggleOpen}
                />
            ) : (
                <Dialog
                    onClose={toggleOpen}
                    aria-labelledby="customized-dialog-snapshot"
                    fullWidth
                    maxWidth={'md'}
                    open={toggle}
                >
                    <Stack direction="column" spacing={3} margin={4}>
                        <Stack>
                            <Stack direction="row" justifyContent="space-between">
                                <DialogTitle id="customized-dialog-shapshot" sx={{ paddingLeft: 0 }}>
                                    <Typography variant="22x700">Capture Snapshot</Typography>
                                </DialogTitle>
                                <IconButton
                                    aria-label="delete"
                                    disabled={isLoading}
                                    autoFocus
                                    onClick={toggleOpen}
                                    sx={{ color: 'figma.grayscale.tier1' }}
                                >
                                    <HighlightOffIcon />
                                </IconButton>
                            </Stack>
                            <Divider sx={{ mt: '0px' }} />
                        </Stack>
                        <Stack>
                            <Typography>Snapshot note (optional)</Typography>
                            <TextField
                                id="snapshot-note"
                                placeholder="Enter Snapshot note here"
                                fullWidth
                                onChange={(e) => setNote(e.target.value)}
                                disabled={isLoading}
                                onFocus={(event) => {
                                    event.target.setAttribute('autocomplete', 'off')
                                }}
                            />
                        </Stack>

                        {isError && (
                            <Stack sx={{ width: '100%' }} spacing={2}>
                                <Alert severity="error" sx={{}}>
                                    Error saving snapshot!
                                </Alert>
                            </Stack>
                        )}
                        <Stack direction="row" justifyContent="flex-end">
                            {isError ? (
                                <LoadingButton
                                    disabled={isLoading}
                                    loading={isLoading}
                                    onClick={handleSnapshotCreate}
                                    variant="text"
                                    color="primary"
                                >
                                    Retry
                                </LoadingButton>
                            ) : (
                                <LoadingButton
                                    loading={isLoading}
                                    variant={'contained'}
                                    sx={{
                                        '& .MuiLoadingButton-loadingIndicator': {
                                            color: 'white',
                                        },
                                        width: '100px',
                                        borderRadius: '14px',
                                        '&.Mui-disabled': {
                                            opacity: 1,
                                            backgroundColor: 'figma.primary',
                                        },
                                    }}
                                    autoFocus
                                    onClick={handleSnapshotCreate}
                                >
                                    Create
                                </LoadingButton>
                            )}
                        </Stack>
                    </Stack>
                </Dialog>
            )}
        </>
    )
}

export default SnapshotModal
